import React from "react";
import { useNavigate } from "react-router-dom";
import BackGroundColor from "../CommanComponents/BackGroundColor";

function CautionModel({ visable, Close }) {
  const navigate = useNavigate();
  const handleExıt = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("postUser");
    navigate("/login");
  };

  if (!visable) return null;

  return (
    <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-25 p-4 backdrop-blur-sm">
      <BackGroundColor />

      {/* Duyarlı Kart Yapısı */}
      <div className="w-full max-w-sm sm:max-w-md h-auto bg-yellow-500 flex flex-col justify-center items-center p-6 sm:p-10 rounded-2xl gap-4 z-50 shadow-2xl">
        {/* İkon Alanı */}
        <div className="flex items-center group cursor-pointer">
          <img
            src="icons.png"
            alt="icon"
            className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl object-cover"
          />
        </div>

        {/* Metin Alanı */}
        <div className="flex justify-center items-center text-gray-900 text-center px-2">
          <h3 className="text-base sm:text-lg font-semibold leading-normal">
            uygulamadan çıkmak istediğinizden emin misiniz?
          </h3>
        </div>

        {/* Butonlar Alanı: Her ekranda yan yana (flex-row) */}
        <div className="flex flex-row justify-center items-center gap-3 sm:gap-5 p-2 w-full mt-2">
          <button
            onClick={handleExıt}
            className="flex-1 sm:flex-none bg-green-600 hover:bg-green-700 text-white font-medium px-6 sm:px-8 py-2.5 rounded-xl transition-colors shadow-md text-center white-space-nowrap"
          >
            Evet
          </button>
          <button
            onClick={Close}
            className="flex-1 sm:flex-none bg-red-600 hover:bg-red-700 text-white font-medium px-6 sm:px-8 py-2.5 rounded-xl transition-colors shadow-md text-center white-space-nowrap"
          >
            Hayır
          </button>
        </div>
      </div>
    </div>
  );
}

export default CautionModel;
